import {useI18n} from '@logistics-frontend/core/i18n'
import {useMemo} from 'react'

import {ZonalPrice} from '../../types'
import {formatWhiteListItemsProp, getTransferDistanceIntervals, getTransferTimeIntervals} from '../../utils'
import {DetailsList} from '../details-list'

type Props = {
  transferDetails: ZonalPrice
  currencySign: string
  title?: string
}

const TransferRideBlock: React.FC<Props> = ({currencySign, transferDetails, title}) => {
  const t = useI18n()

  const items = useMemo(() => {
    return formatWhiteListItemsProp([
      ...getTransferDistanceIntervals(transferDetails, `${currencySign}/${t('tariffs.units.distance')}`, t),
      ...getTransferTimeIntervals(transferDetails, `${currencySign}/${t('tariffs.units.time')}`, t),
    ])
  }, [currencySign, t, transferDetails])

  return <DetailsList items={items} title={title} />
}

export default TransferRideBlock
